import Image from 'next/image';
import styled from 'styled-components';

import { getPurpurBorder, getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const BannerContainer = styled.picture`
    display: block;
    overflow: hidden;
    margin-bottom: ${getPurpurSpacing('200')};
    border-radius: ${getPurpurBorder('radiusLg')};

    ${purpurMedia('md')` 
        margin-bottom: ${getPurpurSpacing('400')};
        margin-top: ${getPurpurSpacing('200')};
    `}
`;

export const BannerImage = styled(Image)`
    display: 'block';
    height: auto;
    width: 100%;
`;
